import localize from '../../util/localize.js';

var ProductResultTaxonomy = {
  id: 'PRODUCTS',
  localizedHeader: function localizedHeader(locale) {
    return localize('Products', locale);
  }
};
var CategoriesResultTaxonomy = {
  id: 'CATEGORIES',
  localizedHeader: function localizedHeader(locale) {
    return localize('categories', locale);
  }
};
var ProductResultBertTaxonomy = {
  id: 'PRODUCTS_BERT',
  localizedHeader: function localizedHeader(locale) {
    return localize('Products', locale);
  }
};
var DesignResultTaxonomy = {
  id: 'DESIGNS',
  localizedHeader: function localizedHeader(locale) {
    return localize('Designs', locale);
  }
};
var HelpResultTaxonomy = {
  id: 'HELP_CENTER',
  localizedHeader: function localizedHeader(locale) {
    return localize('Help Center', locale);
  }
};
var InspirationResultTaxonomy = {
  id: 'INSPIRATION',
  localizedHeader: function localizedHeader(locale) {
    return localize('Inspiration', locale);
  }
};
var CustomerWorkResultTaxonomy = {
  id: 'CUSTOMER_WORK_RESULTS',
  localizedHeader: function localizedHeader(locale) {
    return localize('PersonalizedResults', locale);
  }
};
var DiscoveryPagesTaxonomy = {
  id: 'DISCOVERY_PAGES'
};
var RecentSearchesTaxonomy = {
  id: 'RECENT_SEARCHES'
};
var PopularSearchesTaxonomy = {
  id: 'POPULAR_SEARCHES'
};
var SuggestedQueriesTaxonomy = {
  id: 'SUGGESTED_QUERIES'
};

export { CategoriesResultTaxonomy, CustomerWorkResultTaxonomy, DesignResultTaxonomy, DiscoveryPagesTaxonomy, HelpResultTaxonomy, InspirationResultTaxonomy, PopularSearchesTaxonomy, ProductResultBertTaxonomy, ProductResultTaxonomy, RecentSearchesTaxonomy, SuggestedQueriesTaxonomy };
//# sourceMappingURL=Taxonomies.js.map
